import { useState } from "react";
import "./App.css";
import theuz from "../theuz/imgTheuz/theuz.png";

const IconMail = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
    <polyline points="22,6 12,13 2,6"></polyline>
  </svg>
);
const IconLinkedin = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
    <rect x="2" y="9" width="4" height="12"></rect>
    <circle cx="4" cy="4" r="2"></circle>
  </svg>
);
const SvgWebsiteMockup = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 200 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Browser Frame */}
    <rect
      width="200"
      height="150"
      rx="8"
      fill="white"
      stroke="#E5E5E5"
      strokeWidth="2"
    />
    <path
      d="M1 9C1 4.58172 4.58172 1 9 1H191C195.418 1 199 4.58172 199 9V25H1V9Z"
      fill="#F3F3F3"
    />
    <circle cx="15" cy="13" r="3" fill="#DDDDDD" />
    <circle cx="25" cy="13" r="3" fill="#DDDDDD" />
    <circle cx="35" cy="13" r="3" fill="#DDDDDD" />
    {/* Website Content - Grid Layout */}
    <g transform="translate(10, 35)">
      {/* Header Placeholder */}
      <rect width="180" height="20" rx="2" fill="#EEEEEE" />
      {/* Grid Row 1 */}
      <rect y="30" width="55" height="35" rx="2" fill="#4CAF50" />
      <rect
        x="62.5"
        y="30"
        width="55"
        height="35"
        rx="2"
        fill="#4CAF50"
        opacity="0.7"
      />
      <rect
        x="125"
        y="30"
        width="55"
        height="35"
        rx="2"
        fill="#333333"
        opacity="0.3"
      />
      {/* Grid Row 2 */}
      <rect y="75" width="55" height="35" rx="2" fill="#4CAF50" />
      <rect x="62.5" y="75" width="55" height="35" rx="2" fill="#EEEEEE" />
      <rect x="125" y="75" width="55" height="35" rx="2" fill="#EEEEEE" />
    </g>
  </svg>
);
const SvgLandingPageMockup = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 200 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Browser Frame */}
    <rect
      width="200"
      height="150"
      rx="8"
      fill="white"
      stroke="#E5E5E5"
      strokeWidth="2"
    />
    <path
      d="M1 9C1 4.58172 4.58172 1 9 1H191C195.418 1 199 4.58172 199 9V25H1V9Z"
      fill="#F3F3F3"
    />
    <circle cx="15" cy="13" r="3" fill="#DDDDDD" />
    <circle cx="25" cy="13" r="3" fill="#DDDDDD" />
    <circle cx="35" cy="13" r="3" fill="#DDDDDD" />
    {/* Landing Page Content */}
    <g transform="translate(15, 40)">
      {/* Left Content (Text) */}
      <rect width="90" height="12" rx="2" fill="#333333" opacity="0.6" />
      <rect y="22" width="70" height="6" rx="2" fill="#333333" opacity="0.2" />
      <rect y="32" width="80" height="6" rx="2" fill="#333333" opacity="0.2" />
      <rect y="42" width="60" height="6" rx="2" fill="#333333" opacity="0.2" />

      <rect y="65" width="30" height="30" rx="4" fill="#4CAF50" opacity="0.5" />
      <rect
        x="38"
        y="70"
        width="50"
        height="6"
        rx="2"
        fill="#333333"
        opacity="0.2"
      />
      <rect
        x="38"
        y="80"
        width="40"
        height="6"
        rx="2"
        fill="#333333"
        opacity="0.2"
      />

      {/* Right Content (Form) */}
      <g transform="translate(105, 0)">
        <rect width="65" height="15" rx="2" fill="#EEEEEE" />
        <rect y="25" width="65" height="15" rx="2" fill="#EEEEEE" />
        <rect y="50" width="65" height="25" rx="4" fill="#4CAF50" />
      </g>
    </g>
  </svg>
);
const SvgAppMobileMockup = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 200 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Phone Frame Container Area */}
    <g transform="translate(60, 5)">
      <rect
        x="1"
        y="1"
        width="80"
        height="140"
        rx="12"
        fill="white"
        stroke="#E5E5E5"
        strokeWidth="2"
      />
      {/* Notch/Speaker */}
      <path
        d="M30 10H50"
        stroke="#E5E5E5"
        strokeWidth="2"
        strokeLinecap="round"
      />

      {/* App Screen Content */}
      <g transform="translate(10, 25)">
        {/* Header UI */}
        <rect width="12" height="2" rx="1" fill="#CCCCCC" />
        <rect y="5" width="12" height="2" rx="1" fill="#CCCCCC" />
        <circle cx="55" cy="3" r="5" fill="#EEEEEE" />

        {/* Charts Section */}
        <rect
          y="25"
          width="30"
          height="6"
          rx="2"
          fill="#333333"
          opacity="0.3"
        />
        <g transform="translate(0, 40)">
          {/* Bar Chart */}
          <rect x="2" y="20" width="8" height="25" rx="2" fill="#4CAF50" />
          <rect
            x="16"
            y="10"
            width="8"
            height="35"
            rx="2"
            fill="#4CAF50"
            opacity="0.6"
          />
          <rect
            x="30"
            y="5"
            width="8"
            height="40"
            rx="2"
            fill="#333333"
            opacity="0.2"
          />
          <rect
            x="44"
            y="15"
            width="8"
            height="30"
            rx="2"
            fill="#333333"
            opacity="0.4"
          />
          <line x1="0" y1="50" x2="60" y2="50" stroke="#EEEEEE" />
        </g>

        {/* List items below chart */}
        <g transform="translate(0, 100)">
          <rect width="60" height="12" rx="2" fill="#F5F5F5" />
          <rect y="18" width="60" height="12" rx="2" fill="#F5F5F5" />
        </g>
      </g>
    </g>
  </svg>
);

function Theuz() {
  const [language, setLanguage] = useState("en");
  const [loading, setLoading] = useState(false);
  const [activeFlag, setActiveFlag] = useState("us");

  const handleLanguageChange = (lang, flag) => {
    if (language !== lang) {
      setLoading(true);
      setTimeout(() => {
        setLanguage(lang);
        setActiveFlag(flag);
        setLoading(false);
      }, 3000);
    }
  };
  return (
    <>
      {loading && (
        <div className="loader-screen-pf">
          <div className="loading-overlay-pf">
            <div className="loader-pf">
              <svg viewBox="0 0 80 80">
                <circle r="32" cy="40" cx="40"></circle>
              </svg>
            </div>
            <div className="loader-pf triangle-pf">
              <svg viewBox="0 0 86 80">
                <polygon points="43 8 79 72 7 72"></polygon>
              </svg>
            </div>
            <div className="loader-pf">
              <svg viewBox="0 0 80 80">
                <rect height="64" width="64" y="8" x="8"></rect>
              </svg>
            </div>
          </div>
        </div>
      )}
      {/* HEADER */}
      <header className="header-tz">
        <div className="header-tz-container">
          <div className="logo">
            <img src={theuz} alt="" />
          </div>
          <div className="pf-flags">
            <img
              src="https://placehold.co/50x30?text=BR"
              alt="Bandeira Brasileira"
              className={activeFlag === "br" ? "flag-clicked" : ""}
              onClick={() => handleLanguageChange("pt", "br")}
            />
            <img
              src="https://placehold.co/50x30?text=US"
              alt="Bandeira Americana"
              className={activeFlag === "us" ? "flag-clicked" : ""}
              onClick={() => handleLanguageChange("en", "us")}
            />
          </div>
        </div>
      </header>
      <main>
        {/* HERO SECTION */}
        <section className="hero">
          <div className="hero-content">
            <h1>
              {language === "en" ? (
                <>TRANSFORM YOUR DIGITAL PRESENCE</>
              ) : (
                <>TRANSFORME SUA PRESENÇA DIGITAL</>
              )}
            </h1>
            <p className="subtitle">
              {language === "en" ? (
                <>Modern Websites, SEO & Apps</>
              ) : (
                <>Websites, SEO & Apps Modernos</>
              )}
            </p>

            <div className="social-icons">
              <a href="mailto:theuz.solutions@gmail.com"
                target="_blank"
                rel="noopener noreferrer" className="icon-btn">
                <IconMail />
              </a>
              <a href="https://www.linkedin.com/in/matheuz-franca/"
                target="_blank"
                rel="noopener noreferrer" className="icon-btn">
                <IconLinkedin />
              </a>
            </div>
          </div>
        </section>

        {/* PRODUCTS / CARDS SECTION */}
        <section className="products-section" id="produtos">
          <h3 className="section-label">
            {language === "en" ? <>PRODUCTS</> : <>PRODUTOS</>}
          </h3>

          <div className="products-track">
            <a href="mailto:theuz.solutions@gmail.com?subject=Orçamento%20de%20Website"
              className="product-card"
            >
              <div className="card-image bg-dark">
                <SvgWebsiteMockup />
              </div>
              <h4>WEBSITES</h4>
              <ul>
                <li>
                  {language === "en" ? (
                    <>Custom Design</>
                  ) : (
                    <>Design Customizado</>
                  )}
                </li>
                <li>
                  {language === "en" ? (
                    <>SEO Optimized</>
                  ) : (
                    <>Otimizado para SEO</>
                  )}
                </li>
              </ul>
            </a>

            <a href="mailto:theuz.solutions@gmail.com?subject=Orçamento%20de%20Landing%20Page" className="product-card">
              <div className="card-image bg-light">
                <SvgLandingPageMockup />
              </div>
              <h4>LANDING PAGES</h4>
              <ul>
                <li>
                  {language === "en" ? (
                    <>High Conversion</>
                  ) : (
                    <>Alta conversão</>
                  )}
                </li>
                <li>
                  {language === "en" ? (
                    <>Responsive Design</>
                  ) : (
                    <>Design Responsivo</>
                  )}
                </li>
              </ul>
            </a>

            <a href="mailto:theuz.solutions@gmail.com?subject=Orçamento%20de%20App%20Mobile" className="product-card">
              <div className="card-image bg-light">
                <SvgAppMobileMockup />
              </div>
              <h4>{language === "en" ? <>MOBILE APP</> : <>APP MOBILE</>}</h4>
              <ul>
                <li>
                  {language === "en" ? (
                    <>iOS and Android</>
                  ) : (
                    <>iOS e Android</>
                  )}
                </li>
                <li>
                  {language === "en" ? (
                    <>Native Performance</>
                  ) : (
                    <>Performance nativa</>
                  )}
                </li>
              </ul>
            </a>
          </div>
        </section>

        {/* INFO & FORM GRID */}
        <section className="info-grid">
          <div className="contact-column">
            <h3>
              {language === "en" ? (
                <>READY TO INNOVATE?</>
              ) : (
                <>PRONTO PARA INOVAR?</>
              )}
            </h3>
            <h4>
              {language === "en" ? (
                <>REQUEST YOUR NO-OBLIGATION QUOTE.</>
              ) : (
                <>SOLICITE SEU ORÇAMENTO SEM COMPROMISSO.</>
              )}
            </h4>
            <p>
              {language === "en" ? (
                <>
                  Contact us today to request a quote or ask your questions. We
                  will respond quickly!
                </>
              ) : (
                <>
                  Entre em contato conosco hoje mesmo para pedir um orçamento ou
                  tirar suas dúvidas. Responderemos rapidamente!
                </>
              )}
            </p>
            <p>
              {language === "en" ? (
                <>
                  Available Monday to Friday | From 10am to 5pm (Portugal Time)
                </>
              ) : (
                <>
                  Disponíveis de 2ª a 6ª | Das 10h às 17h (Horário de Portugal)
                </>
              )}
            </p>
            <p>
              {language === "en" ? (
                <>Click the button below and send an email directly to us:</>
              ) : (
                <>
                  Clique no botão abaixo e envie um e-mail diretamente para nós:
                </>
              )}
            </p>
            <div className="social-icons">
              <a href="mailto:theuz.solutions@gmail.com"
                target="_blank"
                rel="noopener noreferrer" className="icon-btn">
                <IconMail />
              </a>
              <a href="https://www.linkedin.com/in/matheuz-franca/"
                target="_blank"
                rel="noopener noreferrer" className="icon-btn">
                <IconLinkedin />
              </a>
            </div>
          </div>

          <div className="text-column">
            <h3>{language === "en" ? <>WHO WE ARE</> : <>QUEM SOMOS</>}</h3>
            <h4>
              {language === "en" ? (
                <>SOLID TRAJECTORY</>
              ) : (
                <>TRAJETÓRIA SÓLIDA</>
              )}
            </h4>
            <p>
              {language === "en" ? (
                <>
                  We are specialists in high-impact web design, dedicated to
                  creating digital solutions that turn into real business
                  opportunities.
                </>
              ) : (
                <>
                  Somos especialistas em design web de alto impacto, dedicados a
                  criar soluções digitais que se transformam em oportunidades
                  reais de negócio.
                </>
              )}
            </p>
            <p>
              {language === "en" ? (
                <>
                  Our focus is clear: increase your sales and optimize processes
                  to ensure the sustainable growth of your brand in the online
                  environment. We combine attractive design with practical
                  technology.
                </>
              ) : (
                <>
                  Nosso foco é claro: aumentar suas vendas e otimizar processos
                  para garantir o crescimento sustentável da sua marca no
                  ambiente online. Unimos design atrativo com tecnologia
                  prática.
                </>
              )}
            </p>
          </div>

          <div className="text-column">
            <h3>{language === "en" ? <>ABOUT US</> : <>SOBRE NÓS</>}</h3>
            <p>
              {language === "en" ? (
                <>
                  Our Mission is to make the digital journey more accessible,
                  practical, and profitable for you.
                </>
              ) : (
                <>
                  Nossa Missão é tornar a jornada digital mais acessível,
                  prática e rentável para você.
                </>
              )}
            </p>
            <p>
              {language === "en" ? (
                <>Our Key Values:</>
              ) : (
                <>Nossos Valores Chave:</>
              )}

              <ul>
                <li>
                  {language === "en" ? (
                    <>
                      Innovation: At the forefront of trends and technologies.
                    </>
                  ) : (
                    <>Inovação: Na vanguarda das tendências e tecnologias.</>
                  )}
                </li>
                <li>
                  {language === "en" ? (
                    <>Quality: Meticulous attention to every project detail.</>
                  ) : (
                    <>
                      Qualidade: Atenção meticulosa em cada detalhe do projeto.
                    </>
                  )}
                </li>
                <li>
                  {language === "en" ? (
                    <>Integrity: Total transparency and mutual trust.</>
                  ) : (
                    <>Integridade: Transparência total e confiança mútua.</>
                  )}
                </li>
              </ul>
              {language === "en" ? (
                <>
                  We seek long-term partnerships. We are here to make your
                  business shine.
                </>
              ) : (
                <>
                  Buscamos parcerias de longo prazo. Estamos aqui para fazer seu
                  negócio brilhar.
                </>
              )}
            </p>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="copyright">© 2024 THEUZ SOLUTIONS</div>
        <div className="footer-links">
          <a href="/terms">
            {language === "en" ? <>Terms of Use</> : <>Termos de Uso</>}
          </a>
          <a href="privacy">
            {language === "en" ? (
              <>Privacy Policy</>
            ) : (
              <>Política de Privacidade</>
            )}
          </a>
        </div>
      </footer>
    </>
  );
}

export default Theuz;
